import React from 'react';
import { observer } from 'mobx-react';
import { Route, Switch } from 'react-router-dom';

import List from './List';
import Edit from './Edit';
import Import from './import/Import';
import ImportFromSazd from './import-from-sazd';
import './style.scss';

@observer
export default class PlenarySession extends React.Component {

	render() {
		return <Switch>
			<Route path="/admin/plenarysessions" exact component={List} />
			<Route path="/admin/plenarysessions/sazd" component={ImportFromSazd} />
			<Route path="/admin/plenarysessions/create" component={Edit} />
			<Route path="/admin/plenarysessions/:id" exact component={Edit} />
			<Route path="/admin/plenarysessions/:id/import" component={Import} />
		</Switch>;
		
	}
}